import { NotificationManager } from 'react-notifications';

const successAlert = (message) => {
    NotificationManager.success(message, 'Success', 5000);
};

export default successAlert;